import permissions from "@server/api/permissions";
import { TokenInfo } from "@typings/Identity";
import { NavigationMenuItem } from "@typings/Navigation";

export const NAVIGATION_MENU: NavigationMenuItem[] = [
  { label: "Dashboard", location: "/" },
  { label: "Licences", location: "/licences" },
  { label: "Customers", location: "/customers" },
  {
    label: "Licence Managers",
    location: "/licensors",
    roles: permissions.ADMIN_ROLES.concat([permissions.ROLES_MAP.PARTNER]),
  },
  { label: "Partners", location: "/partners", roles: permissions.ADMIN_ROLES },
];

export const isLocationAvailable = (
  location: string,
  tokenInfo: TokenInfo | null,
) => {
  const menuItem = NAVIGATION_MENU.find(item => item.location === location);
  if (!menuItem) {
    return false;
  }
  if (!menuItem.roles) {
    return true;
  }
  if (!tokenInfo) {
    return false;
  }
  return menuItem.roles.some(r => tokenInfo?.roles.find(tr => tr.name === r));
};
